import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../rootStore";

export const selectCurrentExamMLResult = ({ examMLResult }: RootState) => examMLResult.currentExamMLResult;

export const selectLoading = ({ examMLResult }: RootState) => examMLResult.loading;


